// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// element
import {Icon} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Icon);
import ElementUI from "element-ui";
Vue.use(ElementUI);

Vue.config.productionTip = false
// 公共的css

import "../static/css/bootstrap.min.css"
import "../src/assets/css/old/all.css"
import "../src/assets/css/old/reset.css"

import "../src/assets/css/public.css"
import "../src/assets/fonts/iconfont.css";
//原来的老代码样式

// util
import util from '@/util/util'
Vue.prototype.util = util;

import "babel-polyfill"

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import $ from 'jquery'
import animated from 'animate.css' 
Vue.use(animated)

import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo)


new Vue({
  router,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js